import { connect } from 'react-redux';

import {
  cyclesForUpdateExamAction,
  setSwitchPfeSktAction,
} from '../../actions/accountSettingsAction';
import {
  setExamQuestions,
  setPracticeExam,
  setResultsSummarized,
  setReviewMode,
} from '../../actions/practiceExamActions';
import { getPossibleCyclesForUpdateExam } from '../../components/AccountSettings/AccountSettingsSelectors';
import ChangeRatingExam from '../../components/AccountSettings/MyProfile/ChangeRatingExam/ChangeRatingExamView';

const mapStateToProps = (state) => ({
  cycles: getPossibleCyclesForUpdateExam(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSwitchPfeSkt: (value) => dispatch(setSwitchPfeSktAction(value)),
  setReviewMode: (value) => dispatch(setReviewMode(value)),
  setPracticeExam: (exam) => dispatch(setPracticeExam(exam)),
  setExamQuestions: (questions) => dispatch(setExamQuestions(questions)),
  setResultsSummarized: (results) => dispatch(setResultsSummarized(results)),
  cyclesForUpdateExam: (rate, rank, dudyState) =>
    dispatch(cyclesForUpdateExamAction(rate, rank, dudyState)),
});

const ChangeRatingExamContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeRatingExam);

export default ChangeRatingExamContainer;
